import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getALlowedSections } from "../../controllers/user";
import { clearCache, setCache } from "../../controllers/cache";

const AuthContext = createContext({
  token: '',
  allowedSections: [],
  onLogin: () => {},
  onLogout: () => {},
  onCompleteRegistration: () => {},
});

const useAuth = () => {
  return useContext(AuthContext);
};

const decodeJwt = (token) => {
  return JSON.parse(atob(token.split(".")[1]));
}

const AuthProvider = ({ children }) => {
  const [token, setToken] = useState('');
  const [permissions, setPermissions] = useState([]);
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  const [allowedSections, setAllowedSections] = useState([]);
  const navigate = useNavigate();

  if (!token) {
    let t = localStorage.getItem('token');
    if (t) {
      const decodedJwt = JSON.parse(atob(t.split(".")[1]));
      if(decodedJwt.exp * 1000 < Date.now()) {
        setIsTokenExpired(true);
        localStorage.removeItem('token');
        localStorage.removeItem('sections');
        localStorage.removeItem('permissions');
        clearCache('token');
      }
      else {
        setPermissions(decodedJwt.authInfo.userPermissions);
        setToken(t);
        setCache('token', t, (decodedJwt.exp * 1000) - Date.now());
      }
    }
  }
  
  if (!allowedSections) {
    let s = JSON.parse(localStorage.getItem('sections'));
    if (s) {
      setAllowedSections(s);
    }
  }
  else if (allowedSections && !allowedSections.length) {
    let s = JSON.parse(localStorage.getItem('sections'));
    if (s && JSON.stringify(s) !== JSON.stringify(allowedSections)) {
      setAllowedSections(s);
    }
  }

  useEffect(() => {
    localStorage.setItem('token', token);
    setCache('token', token, 60 * 60 * 1000);
  }, [token]);
  useEffect(() => {
    console.log('Allowed sections: ', allowedSections);
    localStorage.setItem('sections', JSON.stringify(allowedSections));
  }, [allowedSections]);
  useEffect(() => {
    console.log('permissions: ', permissions);
    localStorage.setItem('permissions', JSON.stringify(permissions));
  }, [permissions]);

  const handleLogin = async (data) => {
    setToken(data.token);
    const decodedToken = decodeJwt(data.token);
    setPermissions(decodedToken.authInfo.userPermissions);

    if (data.membership && data.isMembershipComplete && !data.registration) {
      setAllowedSections(data.allowedSections);
      navigate('/app');
    }
    else if (data.membership && !data.isMembershipComplete) {
      console.log('membership', data.membership, data.isMembershipComplete);
      navigate('/registro', { state: {membership: data.membership, confirmNewMembership: data.confirmNewMembership }} );
      // navigate('/app');
    }
  };

  const handleCompleteRegistration = async (newToken) => {
    setToken(newToken);
    const decodedToken = decodeJwt(newToken);
    setPermissions(decodedToken.authInfo.userPermissions);
    const sections = await getALlowedSections(newToken);
    setAllowedSections(sections);
  };

  const handleLogout = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    localStorage.removeItem('token');
    localStorage.removeItem('sections');
    localStorage.removeItem('permissions');
    setToken('');
    setPermissions();
    setAllowedSections([]);
    navigate('/');
  };

  const hasPermission = (permissionKey) => {
    return Object.values(permissions).includes(permissionKey);
  }

  const value = {
    token,
    allowedSections: allowedSections,
    permissions: permissions,
    onLogin: handleLogin,
    onLogout: handleLogout,
    onCompleteRegistration: handleCompleteRegistration,
    hasPermission: hasPermission
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export {
  AuthProvider,
  AuthContext,
  useAuth
};
